<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
	<div>
		<div v-if="step === $const.STEP_SHIPPING_METHOD">
			<v-layout wrap class="section-title section-title-flex">
				<v-flex xs12 md8>
					<h1 class="active" v-bind="ADAattr('h1')" aria-level="1">
						Select Shipping Method
					</h1>
				</v-flex>

				<v-flex xs12 md4 class="co-mass-links" v-if="!flexpayStore">
					Change all to
					<a
						href="#"
						@click.prevent="setMassShipping('fastest')"
						v-bind="ADAattr('button', 'Change all to fastest')"
					>
						Fastest
					</a> or
					<a
						href="#"
						@click.prevent="setMassShipping('cheapest')"
						v-bind="ADAattr('button', 'Change all to cheapest')"
					>
						Cheapest
					</a>
				</v-flex>
			</v-layout>

			<v-layout class="co-products-sections">
				<div v-for="(section, s_index) in sections" :key="s_index" class="co-products">
					<div class="co-products-list-container">
						<ul class="co-products-list">
							<li v-for="(item, index) in section.books">
								<h3 v-if="item.bundled_products_for_multiple_courses">Multiple courses</h3>
								<h3 v-else-if="item.course_code">{{ item.course_code }} &mdash; {{ item.course_name }}</h3>
								<v-container grid-list-md pa-0>
									<v-layout row>
										<v-flex xs4>
											<v-img
													:src="item.cover"
													height="150px"
													contain
													position="top center"
													v-bind="ADAattr('hidden')"
											></v-img>
										</v-flex>

										<v-flex xs8 px-3>
											<h4 class="mb-2" v-bind="[
												ADAattr('focus'),
												ADAattr('label', ADAitemLabel(item.title, item.sku))
											]" aria-level="4" role="heading">
												{{ item.title }}
											</h4>
											<div><strong>{{ `$${formatPrice(item.price)}` }}</strong></div>
											<div>
												{{
												`Qty: ${item.quantity}, Condition: ${item.condition_text}
												${item.condition_additional ? item.condition_additional : ''}`
												}}
											</div>
											<div v-if="item.licence && item.unlimited_vendor !== 'PearsonDIGITAL'">
												{{ item.licence }}
											</div>
											<div v-if="item.ebook_due_date && item.unlimited_vendor !== 'PearsonDIGITAL'" role="heading" aria-level="5" v-bind="[
												ADAattr('focus'),
												ADAattr('label', `Ebook licence expires on ${ADAformatDate(item.ebook_due_date)}`)
											]">
												Exp. Date: {{ item.ebook_due_date }}
											</div>
											<div v-if="item.rental_due_date">
												Return by: {{ formatDate(item.rental_due_date) }}
											</div>
											<div v-bind="ADAattr('hidden')" v-if="item.unlimited_vendor !== 'PearsonDIGITAL'">{{ `ISBN: ${item.sku}` }}</div>
											<div v-if="item.shipping_text && section.group !== 'backorder'"><strong>{{ item.shipping_text }}</strong></div>
											<div class="product-disclaimer-container" v-if="item.disclaimer && item.unlimited_vendor !== 'PearsonDIGITAL'">
												<span aria-hidden="true" class="mdi mdi-information-outline"></span>
												<span>{{ item.notice_label }}</span>
												<div class="product-disclaimer-text">
												  <div class="notice-bridge"></div>
												  <span v-html="item.disclaimer"></span>
												</div>
											</div>
										</v-flex>
									</v-layout>
								</v-container>
							</li>
						</ul>
					</div>
					<div class="hidden-xs-only co-products-spacer"></div>
					<div class="co-shipping-method-container">
						<v-radio-group
								v-model="section.selected_shipping"
								class="co-select-shipping"
								:disabled="submitting"
						>
							<template v-slot:label v-if="!flexpayStore">
								<div class="co-sm-header">
									Select shipping:
								</div>
							</template>
							<v-radio
								v-for="(shipping, s_index) in section.shipping_methods.all_methods"
								:key="shipping.id"
								:value="shipping"
								@change="doTracking()"
								v-bind="ADAattr('label', `
									Shipping method ${customizeShippingLabel(shipping.label)} for ${shipping.total ? '$' + formatPrice(shipping.total) : 'free'}
									${section.selected_shipping.arrival_date_min ? ', earliest estimated delivery: ' + ADAformatDate(section.selected_shipping.arrival_date_min): ''}
									${section.selected_shipping.arrival_date_average ? ', average estimated delivery: ' + ADAformatDate(section.selected_shipping.arrival_date_average): ''}
									${section.selected_shipping.arrival_date_max ? ', latest estimated delivery: ' + ADAformatDate(section.selected_shipping.arrival_date_max): ''}
								`)"
							>
								<template v-slot:label>
									<span class="co-sm-header-content">
										<span>{{ `${customizeShippingLabel(shipping.label)} - ` }}</span>
										<strong>{{ `${shipping.total ? '$' + formatPrice(shipping.total) : 'Free'}` }}</strong>
										<span class="co-select-shipping-tip co-select-shipping-tip-label" v-if="section['local_pickup_address']">
											{{ section['local_pickup_address'].join(', ') }}
										</span>
									</span>
								</template>
							</v-radio>

							<div class="cheap-delivery-icon" v-if="isEstimatedDeliveryExperiment(section, 'variant4')">
								<v-tooltip
										top
										color="white"
										content-class="high-demand-tooltip"
								>
									<template v-slot:activator="{ on }">
										<v-icon
												color="orange"
												v-on="on"
										>
											mdi-alert-circle
										</v-icon>
									</template>
									This is in <span class="high-demand-tooltip-highlighted">high demand</span> and it might get
									delayed due to supply shortages.
								</v-tooltip>
							</div>
						</v-radio-group>

						<div class="co-estimated-delivery-container" v-if="section.selected_shipping.arrival_date_min && showEstimatedDelivery(section)">
							<div class="expensive-delivery-icon" v-if="isEstimatedDeliveryExperiment(section, 'variant4')">
								<v-tooltip
										top
										color="white"
										content-class="high-demand-tooltip"
								>
									<template v-slot:activator="{ on }">
										<v-icon
												v-on="on"
												color="orange"
										>
											mdi-alert-circle
										</v-icon>
									</template>
									This is in <span class="high-demand-tooltip-highlighted">high demand</span> and it might get
									delayed due to supply shortages.
								</v-tooltip>
							</div>
							<div class="coed-title">Estimated delivery</div>

							<v-container grid-list-md text-xs-center pa-0 mt-3 v-if="!checkInternational()">
								<v-layout row>
									<v-flex>Earliest</v-flex>
									<v-flex class="co-text-highlight" v-if="section.selected_shipping.arrival_date_average">Average</v-flex>
									<v-flex>Latest</v-flex>
								</v-layout>
								<v-divider v-bind="ADAattr('hidden')"></v-divider>
								<v-layout row>
									<v-flex>{{ formatEstDate(section.selected_shipping.arrival_date_min) }}</v-flex>
									<v-flex v-if="section.selected_shipping.arrival_date_average"><strong>{{
										formatEstDate(section.selected_shipping.arrival_date_average) }}</strong></v-flex>
									<v-flex>{{ isEstimatedDeliveryExperiment(section, 'variant4') ? '-' : formatEstDate(section.selected_shipping.arrival_date_max) }}</v-flex>
								</v-layout>
							</v-container>
							<div class="co-shipping-international-note" v-if="checkInternational()">Please allow extra time for processing / shipping for international orders</div>
						</div>

						<div class="high-demand-note" v-if="isEstimatedDeliveryExperiment(section, 'variant3') && isCheapestDeliverySelected(section)">
							This is in <span class="high-demand-note-highlighted">high demand</span> and it might get delayed due to supply shortages.
						</div>
						<div class="co-select-shipping-tip" v-html="getPaymentMethodsTip(section)"></div>
					</div>
				</div>
			</v-layout>

			<div class="co-submit-panel">
				<v-btn
						id="btn-checkout-step-shipping-method"
						:dark="!submitting"
						:loading="submitting"
						color="#2170f2"
						v-bind="ADAattr('button-readonly', submitting, 'Continue to payment methods')"
						@click="submit"
				>
					Continue
				</v-btn>
			</div>
		</div>

		<div v-if="step > $const.STEP_SHIPPING_METHOD">
			<div class="section-title">
				<h1 v-bind="ADAattr('h1')" role="heading" aria-level="1">
					Shipping Method
				</h1>

				<div v-if="step > $const.STEP_SHIPPING_METHOD && !disableEditing">
					<a
						href="#"
						class="co-change-link"
						@click.prevent="$emit('change-step', $const.STEP_SHIPPING_METHOD)"
						v-bind="ADAattr('button', 'Change shipping method')"
					>
						{{ select_shipping_method ? 'Close' : 'Change' }}
					</a>
				</div>
			</div>


			<div class="co-products-sections">
				<div v-for="(section, s_index) in sections" :key="s_index" class="co-products co-products-brief">
					<div class="co-products-list-container">
						<ul class="co-products-list">
							<li v-for="(item, index) in section.books">
								<div class="copl-cover">
									<v-img
											:src="item.cover"
											height="100px"
											contain
											position="center center"
											v-bind="ADAattr('hidden')"
									></v-img>
								</div>
								<div class="copl-info">
									<h4 class="mb-2">{{ item.title }}</h4>
									<div>{{ `ISBN: ${item.sku}` }}</div>
								</div>
							</li>
						</ul>
					</div>
					<div class="co-shipping-method-container co-shipping-method-container-selected">
						<div>{{ customizeShippingLabel(section.selected_shipping.label) }} - <strong>{{ `${section.selected_shipping.total ? '$' + formatPrice(section.selected_shipping.total) : 'Free'}` }}</strong></div>
						<div v-if="section.selected_shipping.arrival_date_min">
							<template v-if="section.selected_shipping.arrival_date_average">
								<div>
									Average Estimated Delivery:
									<strong>{{ formatEstDate(section.selected_shipping.arrival_date_average) }}</strong>
								</div>
							</template>
							<template v-else>
								<div>
									Estimated Delivery:
									<strong>
										{{ formatEstDate(section.selected_shipping.arrival_date_min) }}
										-
										{{ formatEstDate(section.selected_shipping.arrival_date_max) }}
									</strong>
								</div>
							</template>
						</div>
					</div>

				</div>
			</div>
		</div>

		<div v-if="step < $const.STEP_SHIPPING_METHOD" class="co-section-todo" v-bind="ADAattr('hidden')">
			<h2>
				Shipping Method
			</h2>
			<p>
				Select Shipping Method
			</p>
		</div>
	</div>
</template>

<script>
import _ from 'lodash';
import {customizeShippingLabel, getPaymentMethodsTip} from './../includes/SpecialCasesHandles';
import {formatDate, formatPrice} from './../includes/Miscellaneous';


export default {
		name: "ShippingMethod",

		props: {
			sections: {
				type: Array,
				default: [],
			},
			step: {
				type: Number,
			},
			disableEditing: {
				type: Boolean,
				default: false,
			},
			submitting: {
				type: Boolean,
				default: false,
			},
			is_usa: {
				type: Boolean,
				default: false,
			},
			flexpayStore: {
				type: String,
				default: null,
			},
		},

		data() {
			return {
				select_shipping_method: false,
				preselected_shipping_method: false,
				estimated_delivery_experiment_variants: ['variant1', 'variant2', 'variant3', 'variant4']
			};
		},

		beforeUpdate() {
			if (!this.preselected_shipping_method && _.map(this.sections, 'shipping_methods').length > 0 && this.$globs['checkout_preferences']['shipping']) {
				this.preselected_shipping_method = true;
				this.setMassShipping(this.$globs['checkout_preferences']['shipping']);
			}
		},

		methods: {
			formatPrice,
			formatDate,
			customizeShippingLabel,

			submit() {
				const self = this;

				let shipping_methods = {};
				_.each(self.sections, (x) => {
					if (['exchange', 'rental'].includes(x.group)) {
						if (_.isUndefined(shipping_methods[x.group])) {
							shipping_methods[x.group] = {};
						}

						shipping_methods[x.group][x.books[0].id] = x.selected_shipping.id;
					} else {
						shipping_methods[x.group] = x.selected_shipping.id;
					}
				});

				self.$emit('submit', {
					success: true,
					data: {
						shipping_methods,
					},
				});
			},

			formatEstDate(date) {
				return date;
			},

			getPaymentMethodsTip(section) {
				return getPaymentMethodsTip(this.$globs, section);
			},

			checkInternational() {
				const self = this;
				return !self.is_usa;
			},

			doTracking() {
				if (typeof sendGAAction === 'function') {
					sendGAAction('Checkout: shipment level changed (one item)');
				}
			},

			setMassShipping(value) {
				const self = this;

				if (value === null || value === 'default') return;

				_.forEach(self.sections, section => {
					if (!section['shipping_methods'] || !section['shipping_methods']['all_methods']) {
						return;
					}

					let to_select = _.minBy(_.values(section['shipping_methods']['all_methods']), method => {
						if (value === 'cheapest') {
							return parseFloat(method['item']);
						} else { // fastest
							return parseFloat(method['transit_min']);
						}
					});

					if (!to_select) {
						return;
					}

					section['selected_shipping'] = to_select;
				});

			},

			isEstimatedDeliveryExperiment(section, variant) {
				return section.group === 'backorder' && this.$globs.estimated_delivery_variant === variant;
			},

			showEstimatedDelivery(section) {
				if (section.group === 'backorder') {
					return false;  
				}
        
				const estimated_delivery_variant = this.$globs.estimated_delivery_variant;

				if (this.estimated_delivery_experiment_variants.indexOf(estimated_delivery_variant) === -1
						|| estimated_delivery_variant === 'variant1') {
					return true;
				}

				return !this.isCheapestDeliverySelected(section);
			},

			isCheapestDeliverySelected(section) {
				if (!section.selected_shipping || !section.shipping_methods || !section.shipping_methods.all_methods) {
					return false;
				}

				const min_price_shipping = _.minBy(_.values(section.shipping_methods.all_methods), method => {
					return parseFloat(method.total);
				});

				if (!min_price_shipping) {
					return false;
				}

				return section.selected_shipping.id === min_price_shipping.id;
			},

		},

		watch: {},
	};
</script>

<style scoped lang="less">
	@text_highlight_color: #2170f2;

	.co-products-sections {
		flex-direction: column;

		.co-products {
			display: flex;
			justify-content: space-between;
			border-top: 1px solid #E0E0E0;
			padding: 10px 0;

			@media screen and (max-width: 600px) {
				flex-direction: column;
			}

			&:first-child {
				border-top: none;
			}

			.co-products-spacer {
				width: 20px;
			}

			.co-products-list-container {
				@media screen and (min-width: 600px) {
					flex: 6;
				}

				ul.co-products-list {
					list-style: none;

					> li {
						overflow: hidden;
						padding: 10px 0;

						border-top: 1px solid #E0E0E0;

						&:first-child {
							border-top: none;
						}

						h3 {
							color: #767676;
							font-size: 16px;
							font-weight: normal;
							margin-bottom: 10px;
							text-transform: uppercase;
						}

						.copl-cover {
							display: block;
							float: left;
							width: 15%;
						}

						.copl-info {
							display: block;
							box-sizing: border-box;
							float: left;
							width: 85%;
							padding: 10px;

							div {
								font-size: 14px;
							}
						}
					}
				}
			}
			.product-disclaimer-text {
				margin-top: 20px;
				position: absolute;
			}
		}

		/deep/ .co-shipping-method-container {
			font-size: 15px;
			padding: 10px;
			@media screen and (min-width: 600px) {
				flex: 4;
			}

			.co-shipping-international-note {
				font-size: 13px;
				padding-top: 10px;
			}

			.co-select-shipping {
				margin: 0;
				padding: 0;

				.v-label {
					font-size: 15px;
				}
			}

			.co-select-shipping-tip {
				padding: 0 0 15px;
				color: @text_highlight_color;
				display: block;

				&.co-select-shipping-tip-label {
					padding: 5px 0;
				}

				&:empty {
					display: none;
				}

				.csst-normal {
					color: #525b63;
					display: inline-block;
					width: 95%;
				}
			}

			&.co-shipping-method-container-selected {
				padding: 20px;
				box-sizing: border-box;
			}

			.co-sm-header {
				font-size: 15px;
				font-weight: bold;

				strong {
					color: @text_highlight_color;
				}
			}

			.co-estimated-delivery-container {
				border: 1px solid #E0E0E0;
				padding: 10px;
				margin-bottom: 20px;
			}

			.high-demand-note {
				background-color: #ffe7d1;
				padding: 10px 12px;
				margin-bottom: 30px;
				border-radius: 5px;
			}

			.high-demand-note-highlighted {
				font-weight: bold;
				text-transform: uppercase;
			}

			.cheap-delivery-icon {
				position: absolute;
				top: 25px;
				right: -15px;
				cursor: pointer;
			}

			.expensive-delivery-icon {
				float: right;
				cursor: pointer;
			}
		}
	}

	.high-demand-tooltip {
		color: #000;
		opacity: 1 !important;
		font-family: Roboto, sans-serif !important;
		font-size: 14px;
		width: 210px;
	}

	.high-demand-tooltip-highlighted {
		font-weight: bold;
	}

	.co-submit-panel {
		padding-top: 15px;
		border-top: 1px solid #E0E0E0;
	}

	/deep/ .section-title-flex {
		overflow: initial !important;
		align-items: center;;

		h1 {
			margin: 0;
			box-sizing: border-box;
		}

		> div {
			box-sizing: border-box;
			padding: 10px 0 !important;

			.co-text-field {
				margin-top: 0;
				padding-top: 0;

				.v-select__selection {
					padding: 0 0 0 10px;
				}
			}
		}
	}

	.co-mass-links {
		font-size: 14px;

		a {
			font-size: 14px !important;
		}
	}
</style>
